// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import SimpleSlotView from './SimpleSlotView';

class SpacerSlotView extends SimpleSlotView {
  render() {
    super.render();
    this.$('.assembly-slot-options .set').remove();
    this.$('.assembly-slot').addClass('assembly-slot-spacer');
    return this;
  }
}

export default SpacerSlotView;
